import HeadingUnderline from '../heading-underline/heading-underline';
import './sponsor-banner.css';

const SponsorBanner = ({ sponsors, title = "THANK YOU TO OUR SPONSORS" }) => {
    if (!sponsors || sponsors.length === 0) {
        return null;
    }

    return (
        <div className="sponsor-banner-wrapper container-fluid section-padding">
            <div className="container">
                <h2 className="text-center text-red section-title">{title}</h2>
                <HeadingUnderline />
                <div className="sponsor-grid">
                    {sponsors.map((sponsor, idx) => (
                        <div key={`sponsor-${idx}`} className="sponsor-item">
                            {sponsor.link ? (
                                <a
                                    href={sponsor.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="sponsor-link"
                                    aria-label={`Visit ${sponsor.name}`}
                                >
                                    <img
                                        src={sponsor.logo}
                                        alt={sponsor.name}
                                        className="sponsor-logo"
                                    />
                                </a>
                            ) : (
                                <img
                                    src={sponsor.logo}
                                    alt={sponsor.name}
                                    className="sponsor-logo"
                                />
                            )}
                        </div>
                    ))}
                </div>
                <p className="text-center sponsor-footer-text">Proudly supporting VEDS research and awareness</p>
            </div>
        </div>
    );
};

export default SponsorBanner;
